import { sseClient } from '#pplx_generated/typespec/rest/sse/client.js';
/**
 * Fetch async related-query chips for a completed entry from the SSE endpoint.
 * Resolves when the stream ends (one `message` event, then `end_of_stream`).
 */
export const fetchRelatedQueries = async ({ entryUUID, signal, onResult, reason, }) => {
    await sseClient.SSE('/rest/sse/related-queries/{entry_uuid}', reason, {
        // The endpoint is GET; sseClient defaults to POST otherwise (→ 405).
        method: 'GET',
        path: { entry_uuid: entryUUID },
        signal,
        handlers: {
            message: (data) => onResult(data),
        },
    });
};
//# sourceMappingURL=fetchRelatedQueries.js.map